import React, { useEffect, useState } from 'react';

import AdminLogin from './AdminLogin';
import { supabase } from '../../../lib/supabase';
import { useNavigate } from 'react-router-dom';

const AdminAuthGuard = ({ children }) => {
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		let cancelled = false;

		const syncSession = async () => {
			const {
				data: { session },
			} = await supabase.auth.getSession();
			if (!cancelled) {
				setIsAuthenticated(!!session);
				setLoading(false);
			}
		};

		syncSession();

		const {
			data: { subscription },
		} = supabase.auth.onAuthStateChange((_event, session) => {
			if (!cancelled) {
				setIsAuthenticated(!!session);
				setLoading(false);
			}
		});

		return () => {
			cancelled = true;
			subscription.unsubscribe();
		};
	}, []);

	const handleLogout = async () => {
		await supabase.auth.signOut();
		setIsAuthenticated(false);
		navigate('/admin/login');
	};

	if (loading) {
		return (
			<div className='min-h-screen bg-gray-50 flex items-center justify-center'>
				<div className='animate-spin rounded-full h-8 w-8 border-b-2 border-[#800020]'></div>
			</div>
		);
	}

	if (!isAuthenticated) {
		return <AdminLogin />;
	}

	return (
		<div className='min-h-screen bg-gray-50'>
			{/* Logout Button */}
			<div className='fixed top-4 right-4 z-50'>
				<button
					onClick={handleLogout}
					className='bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors text-sm'
				>
					Logout
				</button>
			</div>
			{children}
		</div>
	);
};

export default AdminAuthGuard;
